import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignIn from "../components.js/signin/SignIn";
import PrivateRoute from "./PrivateRoute";
import DefaultLayout from "../widgets/DefaultLayout";
import Chats from "../features/chats/Chats";
import ProjectByUser from "../features/projects/ProjectByUser";
import ResearchByUser from "../features/research/ResearchByUser";
import ChatsByUser from "../features/chats/ChatsByUser";
import Projects from "../features/projects/Projects";
import Research from "../features/research/Research";
import ViewChat from "../features/chats/ViewChat";
import OrgLists from "../features/organization/OrgLists";
import CreateOrg from "../features/organization/CreateOrg";
import UserDetailCard from "../features/users/UserDetailCard";
import HotjarHeatmaps from "../features/HotjarHeatMaps";
import Sessions from "../features/sessions/Sessions";
import EditUser from "../features/users/EditUser";
import Dashboard from "../features/dashboard/Dashboard";
import NewUsers from "../features/users/NewUsers";
import RolesForm from "../features/roles/RolesForm";
import Feedback from "../features/feedback/Feedback";
import AgentChatView from "../features/chats/AgentChatView";
import Mails from "../features/mails/Mails";
import RequestDemo from "../features/demo/RequestDemo";
import SendMails from "../features/mailer/SendMail";
import SendUserMailList from "../features/mailer/SendUserList";
import FeedbackDetail from "../features/feedback/FeedbackDetail";
import Maintenance from "../features/maintenance/Maintenance";
// import AddRequestModal from "../features/maintenance/AddMaintenanceModal";
// import DailyUserActivity from "../features/dashboard/DailyUserActivity";
// import FeatureTracking from "../features/dashboard/FeatureTracking";
// import PromptAnalytics from "../features/dashboard/PromptAnalytics";
// import EngagementMetrics from "../features/dashboard/EngagementMetrics";
// import ViewTables from "../features/dashboard/ViewTables";
// import DateRangeInput from "../common/DateRangeInput";

function AppRoutes() {
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<SignIn />} />
          {/* <Route path="/register" element={<SignUp />} /> */}
          <Route element={<PrivateRoute />}>
            <Route element={<DefaultLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              {/* <Route path="/activity" element={<DailyUserActivity />} />
              <Route path="/features" element={<FeatureTracking />} />
              <Route path="/prompts" element={<PromptAnalytics/>} />
              <Route path="/engagement" element={<EngagementMetrics/>} />
              <Route path="/tables" element={<ViewTables />} />  */}
              {/* <Route path="/date-range" element={<DateRangePickerUi />} /> */}
              {/* <Route path="/date-range" element={<DateRangeInput />} /> */}
              {/* <Route path="/users" element={<Users />} /> */}
              <Route path="/users" element={<NewUsers />} />
              <Route path="/chats" element={<Chats />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/sessions" element={<Sessions />} />
              <Route path="/chats" element={<Chats />} />
              <Route path="/research" element={<Research />} />
              <Route path="/chat/:chatId" element={<ViewChat />} />
              <Route path="/agent/:agentId" element={<AgentChatView />} />
              <Route
                path="/feedback/:feedbackId"
                element={<FeedbackDetail />}
              />
              <Route path="/agent/:agentId" element={<AgentChatView />} />
              <Route path="/chats/:userId" element={<ChatsByUser />} />
              <Route path="/projects/:userId" element={<ProjectByUser />} />
              <Route path="/research/:userId" element={<ResearchByUser />} />
              <Route path="/organization" element={<OrgLists />} />
              <Route
                path="/organization/:organizationId"
                element={<ResearchByUser />}
              />
              <Route path="/organization/add" element={<CreateOrg />} />
              <Route path="/user/:userId" element={<UserDetailCard />} />
              <Route path="/edit/:userId" element={<EditUser />} />
              <Route path="/hotjar" element={<HotjarHeatmaps />} />
              <Route path="/roles" element={<RolesForm />} />
              <Route path="/feedback" element={<Feedback />} />
              <Route path="/mails" element={<Mails />} />
              <Route path="/request-demo" element={<RequestDemo />} />
              <Route path="/send-mail" element={<SendMails />} />
              <Route
                path="/email-invites-sent"
                element={<SendUserMailList />}
              />
              <Route path="/maintenance" element={<Maintenance />} />
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default AppRoutes;
